import { apiClient } from './client.ts';
import type { House, Meter, Reading } from '../types/models.ts';

// ─── Houses ──────────────────────────────────────────────────────────────────

export async function getHouses(): Promise<House[]> {
  return apiClient.get('houses').json<House[]>();
}

export async function getHouse(houseId: string): Promise<House> {
  return apiClient.get(`houses/${houseId}`).json<House>();
}

export async function createHouse(data: {
  buildingNumber: string;
  fullAddress?: string;
}): Promise<House> {
  return apiClient.post('houses', { json: data }).json<House>();
}

export async function updateHouse(
  houseId: string,
  data: { buildingNumber?: string; fullAddress?: string }
): Promise<House> {
  return apiClient.patch(`houses/${houseId}`, { json: data }).json<House>();
}

// ─── Members ─────────────────────────────────────────────────────────────────

export async function addMember(houseId: string, userId: string): Promise<unknown> {
  return apiClient.post(`houses/${houseId}/members`, { json: { userId } }).json();
}

export async function removeMember(houseId: string, userId: string): Promise<void> {
  await apiClient.delete(`houses/${houseId}/members/${userId}`);
}

// ─── Meters ──────────────────────────────────────────────────────────────────

export async function getMeters(houseId: string): Promise<Meter[]> {
  return apiClient.get(`houses/${houseId}/meters`).json<Meter[]>();
}

export async function createMeter(
  houseId: string,
  data: {
    type: 'cold' | 'hot';
    serialNumber?: string;
    location?: string;
    hasHeater?: boolean;
    installedAt?: string;
  }
): Promise<Meter> {
  return apiClient.post(`houses/${houseId}/meters`, { json: data }).json<Meter>();
}

// ─── Readings ────────────────────────────────────────────────────────────────

export async function getReadings(meterId: string): Promise<Reading[]> {
  return apiClient.get(`meters/${meterId}/readings`).json<Reading[]>();
}

export async function createReading(
  meterId: string,
  data: { value: number; readingDate: string; period: string }
): Promise<Reading> {
  return apiClient.post(`meters/${meterId}/readings`, { json: data }).json<Reading>();
}

export async function correctReading(readingId: string, value: number): Promise<Reading> {
  return apiClient.patch(`readings/${readingId}`, { json: { value } }).json<Reading>();
}
